import { CREDIT_CARD_BRAND_CODES_EN } from "@/data/constants";
import creditcardCheckerjs from "creditcard-checkerjs";
import {getCreditCardBrand} from "@/helpers/helpers";

export const isValidEmail = (value) => {
    return /^.+@[^@]+$/.test(value)
};

export const isValidCreditCardBrand = (value) => {
    return Object.keys(CREDIT_CARD_BRAND_CODES_EN).includes(
        value.toString()
    )
};

export const isCreditCardNumber = (value) => {
    return /^[0-9]{4}$/.test(value)
};

export const isCreditCardFourthNumber = (value) => {
    return /^[0-9]{2,4}$/.test(value)
};

export const isValidCvv = (value) => {
    return /^[0-9]{3,4}$/.test(value)
};

export const isValidExpirationDate = (value) => {
    let month = value.slice(0, 2).toString();
    let year = value.slice(3, 5).toString();

    const d = new Date();
    const currentYear = d.getFullYear().toString().slice(2);
    const currentMonth = d.getMonth() + 1;

    return year > currentYear || (year === currentYear && month > currentMonth);
};


export const isValidYear = (value) => {
    return Number(value) < new Date().getFullYear()
};

export const isValidMonth = (value) => {
    return /^(0[1-9]|1[012])$/.test(value)
};

export const isValidDay = (value) => {
    return /^(0[1-9]|[12][0-9]|3[01])$/.test(value)
};

export const isValidBirthday = (value) => {
    return /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/.test(value)
};

export const isValidHolderName = (value) => {
    return /^[A-Z ]+$/.test(value)
};

export const isValidFullName = (value) => {
    return /^[a-zA-Z\s]+$/.test(value)
};

export const isValidName = (value) => {
    return /^[a-zA-Zぁ-ゖァ-ヺ一-龯]+$/.test(value)
};

export const isValidKana = (value) => {
    return /^[ァ-ヶー]+$/u.test(value)
};

export const isValidZipCode = (value) => {
    return /^([0-9]+)$/.test(value) && value.length == 7
};

export const isValidAddress1 = (value) => {
    return /^\d{1,4}$/.test(value)
};

export const isValidAddress2 = (value) => {
    return /^.{3,50}$/.test(value)
};

export const isValidAddress3 = (value) => {
    return /^.{1,100}$/.test(value)
};

export const isValidJapaneseAddress2 = (value) => {
    return /^[a-zA-Z0-9ぁ-ゖァ-ヺ一-龯０-９ー－−‐\-\s　丁目番地号室・\/()（）]{3,50}$/u.test(value)
}

export const isValidJapaneseAddress3 = (value) => {
    return /^[a-zA-Z0-9ぁ-ゖァ-ヺ一-龯０-９ー－−‐\-\s　丁目番地号室・\/()（）]{1,100}$/u.test(value)
}

export const isValidTel = (value) => {
    return /^\d{10,11}$/.test(value)
};


export const isValidForeignAddress = (value) => {
    if (!value) return true;

    return /^[A-Za-z0-9\s\-\/#.,]+$/.test(value);
};

export const isValidSex = (value) => {
    return /^[1-3]$/.test(value)
};

export const isValidCreditCardNumber = (value) => {
    return getCreditCardBrand(value) !== null;
};